<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Our Partners'"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
    <!-- Body Area Start-->
    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 py-4">
            <div class="section-title">
              <span>Our Partners</span>
              <h2>Strategic Partnership to Improve Your Organization's Cyber-Readiness Posture</h2>
            </div>
            <div class="mt-4 text-lg-left">
              <!-- <blockquote class="blockquote my-4">
                <span
                  >If you want to do business with the Federal Government, you
                  need to prove you can protect your systems and data</span
                >
              </blockquote> -->
              <p>
                The Project Spectrum Team prides itself on developing strategic partnerships 
				to raise the level of products and services we can provide you. Prominent among our 
				current strategic partnerships are our formal relationships with the DoD’s Cybersecurity 
				Maturity Model Compliance (CMMC) Program, the Manufacturing Extension Program (MEP), the 
				Mentor-Protégé Program (MPP), and the Small Business Administration (SBA). We urge you to 
				explore and learn more about each of these partners and programs to find out how your participation 
				could improve your organization’s readiness posture. 
                <br /><br />
                As always, if you have any questions, our cyber advisors are here to help! Contact us 
				at <a href="mailto:outreach@projectspectrum.io"> outreach@projectspectrum.io </a>.
              </p>
            </div>
          </div>
          <hr class="col-sm-12" />
		   <div class="col-12 py-2">
            <div class="section-title">
              <h2>OSBP</h2>
            </div>
			<div class="row">
			<div class="col-8">
			 <blockquote class="blockquote">
                <p>The DoD Office of Small Business Programs (OSBP) initiated Project Spectrum as a comprehensive platform to provide the tools and training needed to increase cybersecurity awareness and maintain compliance in accordance with DoD contracting requirements.
				  </p>
              </blockquote>
			 <p style="padding-top:0px">&#9658; <a href="https://business.defense.gov/Programs/Cyber-Security-Resources/"><strong> LEARN MORE </strong> </a> </p>
			</div>
			<div class="col-4">
				<img style="padding: 0px 30px 0px 0px" src="assets/images/OSBP.png" alt="" class="img-fluid w-50"> 
			</div>
			</div>
		  </div>
		   <hr class="col-sm-12" />
          <div class="col-12 py-2">
            <div class="section-title">
              <h2>CMMC</h2>
            </div>
			<div class="row">
			<div class="col-8">
			 <blockquote class="blockquote">
                <p>The Cybersecurity Maturity Model Certification (CMMC) is a unified standard for implementing  cybersecurity across the Defense Industrial Base (DIB), 
				  which includes over 300,000 companies  in the supply chain.
				  </p>
              </blockquote>
			 <p style="padding-top:0px">&#9658; <a href="/#/about-cmmc"><strong> LEARN MORE </strong> </a> </p>
			</div>
			<div class="col-4">
				<img src="assets/images/CMMC.png" alt="" class="img-fluid w-100"> 
			</div>
			</div>
		  </div>
		   <hr class="col-sm-12" />
          <!-- /* CMMC Level 1 Compliance Journey for Small Business */ -->
          <div class="col-12 py-4">
            <div class="section-title">
              <h2>MEP</h2>
            </div>
			<div class="row">
			<div class="col-8">
			 <blockquote class="blockquote">
                <p> Project Spectrum and the Manufacturing Extension Partnership (MEP) are working together  to provide manufacturers with access to a self-directed platform for 
					cutting edge  cybersecurity compliance training and tools.
				  </p>
              </blockquote>
			 <p style="padding-top:0px">&#9658; <a href="/#/mep"><strong> LEARN MORE </strong> </a> </p>
			</div>
			<div class="col-4">
				<img src="assets/images/MEP.png" alt="" class="img-fluid w-100">
			</div>
			</div>
		  </div>
		  <hr class="col-sm-12" />
          <!-- /* CMMC Level 1 Compliance Journey for Small Business */ -->
          <div class="col-12 py-4">
            <div class="section-title">
              <h2>SBA</h2>
            </div>
			<div class="row">
			<div class="col-8">
			 <blockquote class="blockquote">
                <p>
					If you want to do business with any Federal Government agency, you need to know that your  company’s systems and data are secure. Specifically, you need to demonstrate the ability to  safeguard Federal Contract Information (FCI) and Controlled Unclassified 
					Information (CUI)  in order to secure a government contract.
				  </p>
              </blockquote>
			 <p style="padding-top:0px">&#9658; <a href="/#/small-business-administration"><strong> LEARN MORE </strong> </a> </p>
			</div>
			<div class="col-4">
				<img src="assets/images/SBA.png" alt="" class="img-fluid w-100">
			</div>
			</div>
		  </div>
		   <hr class="col-sm-12" />
          <!-- /* CMMC Level 1 Compliance Journey for Small Business */ -->
          <div class="col-12 py-4">
            <div class="section-title">
              <h2>MPP Pilot</h2>
            </div>
			<div class="row">
			<div class="col-8">
			 <blockquote class="blockquote">
                <p>Project Spectrum’s Cybersecurity for Defense Industrial Base Mentor-Protégé Program (MPP) Pilot helps eligible small businesses improve cybersecurity 
					compliance and cyber incident  reporting and hygiene.
				  </p>
              </blockquote>
			 <p style="padding-top:0px">&#9658; <a href="/#/pilot-program"><strong> LEARN MORE </strong> </a> </p>
			</div>
			<div class="col-4">
				<img src="assets/images/MPP.png" alt="" class="img-fluid w-100">
			</div>
			</div>
		  </div>
          <hr class="col-sm-12" />
        </div>
      </div>
    </section>
    <!-- Body Area End-->
  </div>
</template>
<script>
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import TitleTextContent from "../library/widgets/title-text-content.vue";
export default {
  name: 'placeholder',
  components: {
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
  },
};
</script>
<style scoped>
.singup-button-desktop {
  background-color: #096cce;
  border-radius: 5px;
  border: none;
  color: white;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: -5px;
  cursor: pointer;
}
.sba_tooltip {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: #008cba;
}
.centered-text {
  color: white;
  font-size: min(1.75vw, 1.5em);
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 0.25em;
  line-height: min(2.0vw, 1.25em);;
}
.sba_tooltip:hover {
  opacity: 1;
}
.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-padding {
  padding-right: 0;
  padding-left: 0;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

@media only screen and (min-width: 992px) {
  .arrow-height {
    height: 8em;
  }
}

@media only screen and (min-width: 576px) and (max-width: 991px) {
  .arrow-height {
    height: 4em;
  }
}

@media only screen and (max-width: 575px) {
  .arrow-height {
    height: 3em;
  }
}
blockquote {
    border-left: 2px solid #f2b636;
	padding: 0px 0 0px 8px;
}
hr {
  margin-top: 0.01em !important;
  margin-bottom: 0.01em !important;
  border-width: 1px;
}
.padding
{
padding: 0px 30px 0px 0px;
}


</style>
